import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const NewsCard = ({
  url, label, title, previewImageSm, previewImageLg,
  previewText, download, showButton, downloadLink, showPreview,
  relevance,
}) => (
  <Fragment>
    <div className="card card-news mdc-card mdc-card--outlined">
      <div className="mdc-card__primary-action">
        <div className="card__asset">
          {(url) ? (
            <a href={url}>
              <picture>
                <source srcSet={previewImageLg} media="(min-width: 1024px)" />
                <source srcSet={previewImageSm} />
                <img src={previewImageSm} alt={title} />
              </picture>
            </a>
          ) : (
            <picture>
              <source srcSet={previewImageLg} media="(min-width: 1024px)" />
              <source srcSet={previewImageSm} />
              <img src={previewImageSm} alt={title} />
            </picture>
          )}
        </div>
      </div>
      <div className="card__content">
        <div className="card__meta text-small-caps">{label}</div>
        <div className="card__title-wrapper">
          <h2 className="title">
            {(url) ? (
              <a href={url}>{title}</a>
            ) : title
            }
          </h2>
          {showPreview ? (
            <div className="card__text">
              <p>{previewText}</p>
            </div>
          ) : null}
          {download
            ? (
              <a className="btn btn--reset btn--tertiary" href={downloadLink} download>
                <span className="btn__text">Download</span>
              </a>
            ) : null}
          {(showButton && url) ? (
            <a className="btn btn--reset btn--tertiary" href={url}>
              <span className="btn__text">Learn more</span>
            </a>
          ) : null}
          {(relevance) ? (
            <p>{`Relevance: ${relevance}`}</p>
          ) : null}
        </div>
      </div>
    </div>
  </Fragment>
);

NewsCard.defaultProps = {
  label: '',
  showPreview: false,
  previewText: '',
  download: false,
  downloadLink: '',
  showButton: false,
  relevance: '',
};

NewsCard.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  showPreview: PropTypes.bool,
  previewText: PropTypes.string,
  previewImageLg: PropTypes.string.isRequired,
  previewImageSm: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  download: PropTypes.bool,
  downloadLink: PropTypes.string,
  showButton: PropTypes.bool,
  relevance: PropTypes.string,
};

export default NewsCard;
